export enum MatButtonType {
  RAISED = 'raised',
  STROKED = 'stroked',
  FLAT = 'flat',
  MENU = 'menu',
}

export enum MatButtonColors {
  PRIMARY = 'primary',
  SECONDARY = 'seconday',
  ACCENT = 'accent',
  WARN = 'warn',
}
